<template>
  <div class="no-page-view">
    404 PAGE VIEW
  </div>
</template>

<script>
export default {
  name: 'NoPageView'
}
</script>

<style lang="scss">
.no-page-view{
  background-color: red;
}
</style>
